var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import DialogFooter from '../Dialogs/DialogFooter';
import DatePickerHeader from './DatePickerHeader';
import DatePickerCalendar from './DatePickerCalendar';
import YearPicker from './YearPicker';
var DatePicker = function (_PureComponent) {
  _inherits(DatePicker, _PureComponent);
  function DatePicker() {
    _classCallCheck(this, DatePicker);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  DatePicker.prototype.render = function render() {
    var _cn;
    var _props = this.props,
      okLabel = _props.okLabel,
      okPrimary = _props.okPrimary,
      onOkClick = _props.onOkClick,
      cancelLabel = _props.cancelLabel,
      cancelPrimary = _props.cancelPrimary,
      onCancelClick = _props.onCancelClick,
      DateTimeFormat = _props.DateTimeFormat,
      locales = _props.locales,
      calendarTempDate = _props.calendarTempDate,
      calendarMode = _props.calendarMode,
      changeCalendarMode = _props.changeCalendarMode,
      style = _props.style,
      className = _props.className,
      inline = _props.inline,
      icon = _props.icon,
      displayMode = _props.displayMode,
      firstDayOfWeek = _props.firstDayOfWeek,
      disableWeekEnds = _props.disableWeekEnds,
      showAllDays = _props.showAllDays,
      disableOuterDates = _props.disableOuterDates,
      headerClassName = _props.headerClassName,
      contentClassName = _props.contentClassName,
      footerClassName = _props.footerClassName,
      calendarClassName = _props.calendarClassName,
      yearPickerClassName = _props.yearPickerClassName,
      calendarDateClassName = _props.calendarDateClassName,
      calendarOuterDateClassName = _props.calendarOuterDateClassName,
      getDateClassName = _props.getDateClassName,
      dateRenderer = _props.dateRenderer,
      calendarTitleClassName = _props.calendarTitleClassName,
      calendarTitleFormat = _props.calendarTitleFormat,
      calendarWeekdayClassName = _props.calendarWeekdayClassName,
      calendarWeekdayFormat = _props.calendarWeekdayFormat,
      props = _objectWithoutProperties(_props, ['okLabel', 'okPrimary', 'onOkClick', 'cancelLabel', 'cancelPrimary', 'onCancelClick', 'DateTimeFormat', 'locales', 'calendarTempDate', 'calendarMode', 'changeCalendarMode', 'style', 'className', 'inline', 'icon', 'displayMode', 'firstDayOfWeek', 'disableWeekEnds', 'showAllDays', 'disableOuterDates', 'headerClassName', 'contentClassName', 'footerClassName', 'calendarClassName', 'yearPickerClassName', 'calendarDateClassName', 'calendarOuterDateClassName', 'getDateClassName', 'dateRenderer', 'calendarTitleClassName', 'calendarTitleFormat', 'calendarWeekdayClassName', 'calendarWeekdayFormat']);
    var picker = void 0;
    if (calendarMode === 'calendar') {
      picker = React.createElement(DatePickerCalendar, _extends({}, props, {
        key: 'calendar',
        className: calendarClassName,
        calendarTempDate: calendarTempDate,
        DateTimeFormat: DateTimeFormat,
        locales: locales,
        firstDayOfWeek: firstDayOfWeek,
        disableWeekEnds: disableWeekEnds,
        showAllDays: showAllDays,
        disableOuterDates: disableOuterDates,
        dateClassName: calendarDateClassName,
        getDateClassName: getDateClassName,
        dateRenderer: dateRenderer,
        outerDateClassName: calendarOuterDateClassName,
        titleClassName: calendarTitleClassName,
        titleFormat: calendarTitleFormat,
        weekdayClassName: calendarWeekdayClassName,
        weekdayFormat: calendarWeekdayFormat
      }));
    } else {
      picker = React.createElement(YearPicker, _extends({}, props, {
        key: 'year',
        className: yearPickerClassName,
        calendarTempDate: calendarTempDate,
        DateTimeFormat: DateTimeFormat,
        locales: locales
      }));
    }
    var actions = [{
      key: 'cancel',
      onClick: onCancelClick,
      primary: cancelPrimary,
      secondary: !cancelPrimary,
      label: cancelLabel
    }, {
      key: 'ok',
      onClick: onOkClick,
      primary: okPrimary,
      secondary: !okPrimary,
      label: okLabel
    }];
    return React.createElement('div', {
      style: style,
      className: cn('md-picker md-picker--date', (_cn = {}, _cn['md-picker--' + displayMode] = displayMode, _cn['md-picker--inline'] = inline, _cn['md-picker--inline-icon'] = inline && icon, _cn), className)
    }, React.createElement(DatePickerHeader, {
      className: headerClassName,
      DateTimeFormat: DateTimeFormat,
      locales: locales,
      calendarTempDate: calendarTempDate,
      calendarMode: calendarMode,
      changeCalendarMode: changeCalendarMode
    }), React.createElement('div', {
      className: cn('md-picker-content-container', contentClassName)
    }, picker, React.createElement(DialogFooter, {
      className: footerClassName,
      actions: actions
    })));
  };
  return DatePicker;
}(PureComponent);
DatePicker.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  okLabel: PropTypes.node.isRequired,
  okPrimary: PropTypes.bool.isRequired,
  onOkClick: PropTypes.func.isRequired,
  cancelLabel: PropTypes.node.isRequired,
  cancelPrimary: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  DateTimeFormat: PropTypes.func.isRequired,
  locales: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  calendarDate: PropTypes.instanceOf(Date).isRequired,
  calendarTempDate: PropTypes.instanceOf(Date).isRequired,
  calendarMode: PropTypes.oneOf(['calendar', 'year']).isRequired,
  changeCalendarMode: PropTypes.func.isRequired,
  icon: PropTypes.bool,
  inline: PropTypes.bool,
  displayMode: PropTypes.oneOf(['landscape', 'portrait']),
  /**
   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
   */
  firstDayOfWeek: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]),
  /**
   * True if weekends are to be greyed out.
   */
  disableWeekEnds: PropTypes.bool,
  /**
   * True if dates from adjacent months should be shown in calendar.
   */
  showAllDays: PropTypes.bool,
  disableOuterDates: PropTypes.bool,
  /**
   * An optional className to apply to the header of date picker.
   */
  headerClassName: PropTypes.string,
  /**
   * An optional className to apply to the content container of date picker.
   */
  contentClassName: PropTypes.string,
  /**
   * An optional className to apply to the footer of date picker.
   */
  footerClassName: PropTypes.string,
  /**
   * An optional className to apply to the calendar container of date picker.
   */
  calendarClassName: PropTypes.string,
  /**
   * An optional className to apply to the year picker of date picker.
   */
  yearPickerClassName: PropTypes.string,
  /**
   * An optional className to apply to a date in calendar.
   */
  calendarDateClassName: PropTypes.string,
  /**
   * An optional className to apply to a date from an adjacent month in calendar.
   */
  calendarOuterDateClassName: PropTypes.string,
  /**
   * An optional function to provide class for each date in calendar.
   */
  getDateClassName: PropTypes.func,
  /**
   * An optional function to render each date component.
   */
  dateRenderer: PropTypes.func,
  /**
   * An optional className to apply to the title in calendar header.
   */
  calendarTitleClassName: PropTypes.string,
  /**
   * The DateTimeFormat options to apply to format the title in calendar header.
   */
  calendarTitleFormat: PropTypes.shape({
    era: PropTypes.oneOf(['narrow', 'short', 'long']),
    year: PropTypes.oneOf(['numeric', '2-digit']),
    month: PropTypes.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
  }),
  /**
   * An optional className to apply to a weekday in calendar header.
   */
  calendarWeekdayClassName: PropTypes.string,
  /**
   * The DateTimeFormat option to apply to format a weekday in calendar header.
   */
  calendarWeekdayFormat: PropTypes.oneOf(['narrow', 'short', 'long'])
};
export default DatePicker;